import { object, string } from 'zod';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { makeZodValidate } from '@occc/ui-forms';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

export const scanDataSubmissionGroupCreateSchema = object({
  name: string({ required_error: IS_REQUIRED }).min(1, IS_REQUIRED),
  tobaccoCompany: string({ required_error: IS_REQUIRED }),
  submissionType: string({ required_error: IS_REQUIRED }),
  sftpDetails: object({
    username: string({ required_error: IS_REQUIRED }).min(1, IS_REQUIRED),
    password: string({ required_error: IS_REQUIRED }).min(1, IS_REQUIRED),
    portNumber: string({ required_error: IS_REQUIRED }).optional(),
    submissionURL: string({ required_error: IS_REQUIRED }).min(1, IS_REQUIRED),
    submitterID: string({ required_error: IS_REQUIRED }).min(1, IS_REQUIRED),
  }),
});

export const validateScanDataSubmissionGroupCreate = makeZodValidate(
  scanDataSubmissionGroupCreateSchema,
);
